module.exports = __webpack_public_path__ + "media/images/hero/hero2-person-ebf6a23b2001f883bb7ebf87a306fb85.png";